module.exports = __webpack_public_path__ + "static/media/snar.bcf205be.m4a";